<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <common-manufacturer-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></common-manufacturer-form>
  </j-modal>
</template>

<script>

  import CommonManufacturerForm from './CommonManufacturerForm'
  export default {
    name: 'CommonManufacturerModal',
    components: {
      CommonManufacturerForm
    },
    data () {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add()
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record)
        })
      },
      close () {
        this.$emit('close')
        this.visible = false
      },
      handleOk () {
        this.$refs.realForm.submitForm()
      },
      submitCallback (id = "") {
        this.$emit('ok', id)
        this.visible = false
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
